<div
  class="tw-flex tw-flex-col xl:!tw-flex-row tw-justify-between tw-px-8 tw-py-4"
>
  <!-- Template for More Options Menu -->
  <ng-template #moreOptionsMenu>
    <button
      id="moreSettingsButton"
      type="button"
      focus-outline
      class="dropdown-toggle tw-flex tw-items-center tw-justify-center tw-ml-[5px] tw-rounded-full tw-p-[5px] tw-border tw-border-solid tw-border-gray-200 tw-bg-transparent"
      [matMenuTriggerFor]="menu"
      aria-label="More options"
    >
      <mat-icon svgIcon="more-vertical" class="tw-rotate-90" />
    </button>
    <mat-menu #menu="matMenu">
      @for (action of actions.moreOptions; track action.id) {
        @if (!action.disabled && action.action && canShowAction(action)) {
          <button
            mat-menu-item
            *requireRole="action.requireRole"
            [id]="action.id"
            (click)="action.action()"
            (keyup.enter)="action.action()"
            [class.rise-admin-only]="action.requireRole === 'sa'"
          >
            @if (action.icon) {
              <mat-icon
                [svgIcon]="action.icon"
                class="small tw-mr-[5px]"
              ></mat-icon>
            }
            {{ action.label }}
            @if (getUpgradeIcon(action); as upgradeIcon) {
              <mat-icon class="small" [svgIcon]="upgradeIcon"></mat-icon>
            }
          </button>
        }
      }
      @if (
        actions.deleteAction &&
        !actions.deleteAction.disabled &&
        actions.deleteAction.action &&
        canShowAction(actions.deleteAction)
      ) {
        <div
          class="tw-border-solid tw-border-0 tw-border-t tw-border-gray-200 tw-pt-[2.5px] tw-mt-[5px]"
        >
          <button
            class="tw-text-red-700"
            mat-menu-item
            [id]="actions.deleteAction.id"
            [class.rise-admin-only]="actions.deleteAction.requireRole === 'sa'"
            (click)="actions.deleteAction.action()"
          >
            @if (actions.deleteAction.icon) {
              <mat-icon
                [svgIcon]="actions.deleteAction.icon"
                class="small tw-mr-[5px]"
              ></mat-icon>
            }
            {{ actions.deleteAction.label }}
          </button>
        </div>
      }
    </mat-menu>
  </ng-template>

  @if (title !== undefined) {
    <div
      class="tw-w-full tw-max-w-1/2 tw-flex tw-flex-row tw-items-center tw-justify-start"
    >
      <!-- Title/Name Input - Only show if title is provided -->
      <stretchy-input [(value)]="title" [ariaLabel]="titleAriaLabel" />

      <!-- More Options Menu - Show here only when title is provided -->
      @if (hasVisibleMoreOptions()) {
        <ng-container [ngTemplateOutlet]="moreOptionsMenu"></ng-container>
      }

      <!-- Optional Custom Component -->
      @if (customComponent) {
        <div class="tw-ml-5">
          <ng-container
            *ngComponentOutlet="customComponent; inputs: componentInputs"
          ></ng-container>
        </div>
      }
    </div>
  }

  <div
    class="tw-flex tw-flex-col xl:!tw-flex-row tw-gap-2.5 tw-items-start xl:!tw-items-center tw-justify-center xl:!tw-justify-end tw-w-full tw-max-w-1/2"
  >
    <p class="tw-text-left xl:!tw-text-right tw-w-full tw-m-0">
      @if (changeDate || changedBy) {
        <last-modified [changeDate]="changeDate" [changedBy]="changedBy">
        </last-modified>
      }
    </p>

    <!-- More Options Menu - Show here when title is NOT provided -->
    @if (title === undefined && hasVisibleMoreOptions()) {
      <ng-container [ngTemplateOutlet]="moreOptionsMenu"></ng-container>
    }

    @if (actions?.cancelAction) {
      <button
        rv-button
        variant="secondary"
        type="button"
        [id]="actions.cancelAction.id"
        (click)="actions.cancelAction.action()"
        class="tw-w-full xl:!tw-max-w-[90px] common-actions-button"
      >
        {{ actions.cancelAction.label }}
      </button>
    }

    @if (actions?.saveAction && canShowAction(actions.saveAction)) {
      <button
        rv-button
        type="submit"
        [id]="actions.saveAction.id"
        class="tw-w-full xl:!tw-max-w-[130px] common-actions-button"
        (click)="actions.saveAction.action?.()"
        [disabled]="actions.saveAction.disabled || saving"
      >
        {{ saving ? 'Saving' : actions.saveAction.label }}
      </button>
    }
  </div>
</div>
